import { useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import {
  getCustomOnboardingLocalUtils,
  getCanDisplayModal,
  getShouldDisplayProfileModal,
} from '../utils';
import { makeSelectOnboardingModals } from '../selectors';

export const ONBOARDING_PAGES = {
  redirect: 'redirectModal',
  reporting: 'reportingModal',
  profile: 'profileModal',
};

const useIsOnboardingEnabled = () => {
  const location = useLocation();
  const onboardingModals = useSelector(makeSelectOnboardingModals);
  const profile = useSelector(state => state.firebase.profile);

  const reportingConfig = _get(onboardingModals, ONBOARDING_PAGES.reporting);
  const redirectConfig = _get(onboardingModals, ONBOARDING_PAGES.redirect);
  const profileConfig = _get(onboardingModals, ONBOARDING_PAGES.profile);

  const canDisplayReporting =
    !_isEmpty(reportingConfig) &&
    getCanDisplayModal({
      trigger: Array.isArray(reportingConfig)
        ? reportingConfig[0].trigger
        : _get(reportingConfig, 'trigger'),
      pathname: location.pathname,
    });

  const canDisplayRedirect =
    !_isEmpty(redirectConfig) &&
    getCanDisplayModal({
      trigger: _get(redirectConfig, 'trigger'),
      pathname: location.pathname,
    });

  const canDisplayProfile =
    !_isEmpty(profileConfig) &&
    getCanDisplayModal({
      trigger: _get(profileConfig, 'trigger'),
      pathname: location.pathname,
    }) &&
    getShouldDisplayProfileModal({
      profile,
      userProfileField: profileConfig?.userProfileField,
    });

  const { get, getDismissed } = getCustomOnboardingLocalUtils();
  const isReportingViewed = get(ONBOARDING_PAGES.reporting);
  const isRedirectViewed = get(ONBOARDING_PAGES.redirect);
  const isProfileViewed = get(ONBOARDING_PAGES.profile);
  const isDismissed = getDismissed();

  const shouldDisplayRedirect =
    !isRedirectViewed && canDisplayRedirect && !isDismissed;
  const shouldDisplayReporting =
    !isReportingViewed && canDisplayReporting && !isDismissed;
  const shouldDisplayProfile = !isProfileViewed && canDisplayProfile;

  return {
    showRedirect: shouldDisplayRedirect,
    showReporting: shouldDisplayReporting,
    showProfile: shouldDisplayProfile,
  };
};

export default useIsOnboardingEnabled;
